// extracted by mini-css-extract-plugin
export default {"content-root":"_2Fnt1","contentRoot":"_2Fnt1","title":"_1mv2-","message":"_1TAD9","image":"_3QHji"};